import '../style.scss';
import React, { useState } from 'react';
import Button from '~/components/button';
import GeniusModal from '~/components/genius_modal';
import SelectFolderInput from '~/components/select_folder_input';
import { useAppSidebar } from '~/layout/main_layout/app_sidebar/provider';
import CreateNewProjectForm from './create_new_project_form';
const AddToProjectForm = (props) => {
    const { setIsAddToProjectVisible, documentComparisonId, onAttachComparison } = props;
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedFolder, setSelectedFolder] = useState(null);
    const [isNewProjectFormVisible, setIsNewProjectFormVisible] = useState(false);
    const { projectsWorkspaces, isArchivedVisible } = useAppSidebar();
    const onFolderSelect = (folder) => {
        setSelectedFolder(folder);
        ToggleFolderExpansion();
    };
    const ToggleFolderExpansion = () => {
        setIsExpanded(!isExpanded);
    };
    const resetUI = () => {
        setIsExpanded(false);
        setSelectedFolder(null);
    };
    const handleCreateNewFolder = (e) => {
        e.preventDefault();
        setIsNewProjectFormVisible(true);
        setIsAddToProjectVisible(false);
    };
    const handleNewFolder = (project) => {
        setSelectedFolder(project);
        onAttachComparison(documentComparisonId, project.id);
        setIsNewProjectFormVisible(false);
    };
    const handleClick = () => {
        onAttachComparison(documentComparisonId, selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.id);
        setIsAddToProjectVisible(false);
        resetUI();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(GeniusModal, { isModalShowing: props.isVisible, onHide: () => { setIsAddToProjectVisible(false); resetUI(); }, headerContent: React.createElement("div", { className: "form-header" }, "Add To Projects"), bodyContent: React.createElement(React.Fragment, null,
                React.createElement("label", { className: 'modal-input-label', htmlFor: 'Location' }, "Assign to folder"),
                React.createElement(SelectFolderInput, { ToggleFolderExpansion: ToggleFolderExpansion, isExpanded: isExpanded, projectsWorkspaces: projectsWorkspaces, isArchivedVisible: isArchivedVisible, selectedId: selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.id, onFolderSelect: onFolderSelect, selectedDisplay: selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.name }),
                React.createElement("button", { className: 'create-folder-button', onClick: handleCreateNewFolder }, "Create a new folder")), footerContent: React.createElement(Button, { className: 'save-btn', primary: true, onClick: handleClick, disabled: !selectedFolder }, "Save") }),
        React.createElement(CreateNewProjectForm, { onCreateNewFolder: handleNewFolder, isVisible: isNewProjectFormVisible, setIsVisible: setIsNewProjectFormVisible })));
};
export default AddToProjectForm;
